import { createRouter } from '@tanstack/react-router'
import { ENV_VITE_BASE_PATH } from './env.ts'
import { routeTree } from './routeTree.gen.ts'

export const router = createRouter({
  // Always match vite base path.
  basepath: ENV_VITE_BASE_PATH,
  routeTree,
  defaultPreload: 'intent',
  // Have the root route handle notFound errors,
  // so it renders 404 page correctly.
  notFoundMode: 'root',
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
